import { render } from "./BreckSchoolBlog.vue?vue&type=template&id=589f37bc&scoped=true"
import script from "./BreckSchoolBlog.vue?vue&type=script&lang=js"
export * from "./BreckSchoolBlog.vue?vue&type=script&lang=js"

import "./BreckSchoolBlog.vue?vue&type=style&index=0&id=589f37bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589f37bc"]])

export default __exports__